// Seller products can only be assigned to terminal catalogue categories that
// define at least one product filter.  The category API returns children and
// filters beside `cartegory`, while a few callers keep them on the category;
// accepting both shapes keeps the rule in one place.
export const isFinalSellerProductCategory = (category, items, filters) => {
  const children = Array.isArray(items) ? items : category?.items;
  const categoryFilters = Array.isArray(filters)
    ? filters
    : (Array.isArray(category?.filter) ? category.filter : category?.filters);

  return Boolean(category?._id)
    && Array.isArray(children)
    && children.length === 0
    && Array.isArray(categoryFilters)
    && categoryFilters.length > 0;
};

